import { FC, useEffect } from 'react';

import { nativeHooks } from '@bluecodecom/native';

import { trackingService } from '../../services';

/**
 * Registers the SDK telemetry session id from the native host config as the
 * `session_id` super property, and re-registers if the host config delivers a
 * new one. Must run inside `NativeProviders.VasHostConfig`.
 *
 * Nothing is registered while the id is unknown (`null`) — older SDK builds
 * that do not send `sdkSessionId` yet simply produce events without it.
 */
export const useSdkSessionSuperProperty = () => {
  const { sdkSessionId } = nativeHooks.useVasHostConfigContext();

  useEffect(() => {
    trackingService.registerSdkSession(sdkSessionId);
  }, [sdkSessionId]);
};

/**
 * Drop-in for apps that have no component of their own below the host-config
 * provider: renders nothing, runs {@link useSdkSessionSuperProperty}.
 */
export const SdkSessionSuperProperty: FC = () => {
  useSdkSessionSuperProperty();

  return null;
};

export default useSdkSessionSuperProperty;
